import React, { useState, useMemo, useCallback, useContext, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Content from "../Components/Content";
import Navigation from "../Components/Navigation";
import Random from "../Components/Random";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button"

import { SavedContext } from "../App";

//importing data
import data from "../data/data.json";

const Index = (props) => {
  //create a vector of date
  const dates = data.map((item) => item.date);
  const dateArray = [...new Set(dates)];
  //converting the dates array in a useful structure
  const dateOptions = [
    {
      value: "all",
      label: "all",
    },
  ];
  for (const dateItem in dateArray) {
    dateOptions.push({
      value: dateArray[dateItem],
      label: dateArray[dateItem],
    });
  }

  //create a vector of topic
  const topics = data.map((item) => item.topic);
  const topicArray = [...new Set(topics)];
  //converting the topics array in a useful structure
  const topicOptions = [
    {
      value: "all",
      label: "all",
    },
  ];
  for (const topicItem in topicArray) {
    topicOptions.push({
      value: topicArray[topicItem],
      label: topicArray[topicItem],
    });
  }

  //create a state for date
  const [date, setDate] = useState(["all"]);
  //create a state for the topics
  const [topic, setTopic] = useState(["all"]);

  //to check easly later
  const dateStateValues = [];
  for (const item in date) {
    dateStateValues.push(date[item]);
  }
  const topicStateValues = [];
  for (const item in topic) {
    topicStateValues.push(topic[item]);
  }

  const results = useMemo(() => {
    return data.filter((item) => {
      if (dateStateValues.includes("all")) {
        if (topicStateValues.includes("all")) {
          return true;
        } else {
          if (topicStateValues.includes(item.topic)) {
            return true;
          }
        }
      } else {
        if (topicStateValues.includes("all")) {
          if (dateStateValues.includes(item.date)) {
            return true;
          }
        } else {
          if (
            dateStateValues.includes(item.date) &&
            topicStateValues.includes(item.topic)
          ) {
            return true;
          }
        }
      }
      return false;
    });
  }, [dateStateValues, topicStateValues]);

  const resultsCount = useMemo(() => results.length, [results]);

  //create a random state to refresh random component
  const [random, setRandom] = useState(0);

  const randomize = useCallback(() => {
    setRandom(Math.floor(Math.random() * resultsCount));
  }, [setRandom, resultsCount]);

  useEffect(() => randomize(), [resultsCount])

  const { saved, setSaved } = useContext(SavedContext);

  const addSave = useCallback(
    (key) => {
      if (!saved.includes(key)) {
        setSaved([...saved, key]);
      }
    },
    [saved, setSaved]
  );

  const removeSave = useCallback(
    (key) => {
      const newArray = [];
      saved.map((item) => {
        if (item != key) {
          newArray.push(item);
        }
      });
      setSaved(newArray);
    },
    [saved, setSaved]
  );

  function AlertDismissibleExample() {
    const [show, setShow] = useState(true);
    if (show) {
      return (
        <Alert variant="secondary" onClose={() => setShow(false)} dismissible>
          <Alert.Heading>Heyo, welcome to this trainer ;)</Alert.Heading>
          <p>
            While using this tool, remember that it is created for <strong>educational purposes only</strong>. <br/>
            Feel free to contribute by suggesting an answer for questions that don't have one yet. <br/>
            Go to <i>Saved</i> in the menu to see answers that you have saved while visiting the website from this device.
          </p>
        </Alert>
      );
    }
    return "";
  }
  

  return (
    <div>
      <Navigation
        parent={"index"}
        date={date}
        setDate={setDate}
        topic={topic}
        setTopic={setTopic}
        topicOptions={topicOptions}
        dateOptions={dateOptions}
        randomize={randomize}
      />

      <Container style={{ marginTop: "80px" }}>
        <AlertDismissibleExample />
        <p className="text-muted">
          {resultsCount>0 ? "This is a random one from the following list" : ""}{" "}
        </p>
        <Random
          dateStateValues={dateStateValues}
          topicStateValues={topicStateValues}
          results={results}
          random={random}
          addSave={addSave}
          removeSave={removeSave}
        />

        <p className="text-muted mt-5">
          {resultsCount == 1
            ? resultsCount + " result found"
            : resultsCount + " results found"}{" "}
        </p>
        <Content
          dateStateValues={dateStateValues}
          topicStateValues={topicStateValues}
          results={results}
          addSave={addSave}
          removeSave={removeSave}
        />
      </Container>
    </div>
  );
};

export default Index;
